












































































































































































































































































































































































import { computed, defineComponent, PropType } from "@vue/composition-api";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import OccLabel from "@/components/Atoms/OccLabel/index.vue";
import OccButton from "@/components/Atoms/OccButton/index.vue";
import Radio from "@/components/Atoms/Forms/Radio/index.vue";
import ToggleContent from "@/components/Atoms/ToggleContent/index.vue";
import FieldErrorMessage from "@/components/Atoms/FieldErrorMessage/index.vue";
import OccSelectboxDate from "@/components/Atoms/OccSelectboxDate/index.vue";
import OccModal from "@/components/Atoms/OccModal/index.vue";
import OccTag from "@/components/Atoms/OccTag/index.vue";
import TextArea from "@/components/Atoms/Forms/TextArea/index.vue";
import ConfirmModal from "@/components/Organisms/modals/ConfirmModal/index.vue";
import PublishConfirmModal from "@/components/Pages/JobEvent/Organisms/Modals/PublishConfirmModal.vue";

import {
  JOB_EVENT_STORE_KEY,
  ValidationError
} from "@/helpers/hooks/useJobEvent";
import { useToggle } from "@/helpers/hooks/useToggle";
import {
  getDisplayApprovalStatus,
  getDisplayPublicStatus,
  goToPreviewPage
} from "@/helpers/jobEvent";
import { getBusinessDate } from "@/helpers/date-helper";
import dayjs from "dayjs";
import { occWhite } from "@/assets/styles/vars-for-script.scss";
import { ApiResponse, BadRequestError } from "@/api/types";
import { getErrorMessages } from "@/helpers/api-helper";
import { useGlobalState } from "@/helpers/hooks/useGlobalState";
import { useStore } from "@/store";
import { useRouter } from "@/router";

export default defineComponent({
  components: {
    OccHeading,
    OccLabel,
    OccButton,
    Radio,
    ToggleContent,
    FieldErrorMessage,
    OccSelectboxDate,
    OccModal,
    OccTag,
    TextArea,
    ConfirmModal,
    PublishConfirmModal
  },
  name: "JobEventSidebar",
  props: {
    isNewJobEvent: {
      type: Boolean,
      default: false
    },
    companyLogoUrl: {
      type: String,
      default: ""
    },
    contracts: {
      type: Array as PropType<ApiResponse.ContractInformation[]>,
      default: () => []
    },
    gaEventCategory: {
      type: String,
      default: ""
    }
  },
  emits: ["completedPublish", "checkCompanyLogo"],
  setup(props, { emit }) {
    const {
      editingJobEvent,
      jobEventErrors,
      comments,
      disabledEdit,
      setEditingJobEvent,
      getJobEventErrorMessage,
      validateAllProperties,
      jobEventValidate,
      saveJobEvent,
      submitJobEvent,
      withdrawJobEvent
    } = useGlobalState(JOB_EVENT_STORE_KEY);
    const store = useStore();
    const router = useRouter();

    const [isShowPublishConfirmModal, togglePublishConfirmModal] = useToggle();

    const [
      isShowPublishCompletedModal,
      togglePublishCompleteModal
    ] = useToggle();

    const [isShowWithdrawConfirmModal, toggleWithdrawConfirmModal] = useToggle(
      false
    );

    const [
      isShowWithdrawCompleteModal,
      toggleWithdrawCompleteModal
    ] = useToggle(false);

    const onChangePreferredPublishAt = (preferredPublishAt: string) => {
      if (!editingJobEvent.value) {
        return;
      }

      setEditingJobEvent(
        {
          ...editingJobEvent.value,
          preferred_publish_at: preferredPublishAt
        },
        { key: "preferred_publish_at" }
      );
    };

    const onChangeSelectedPreferredDateType = (scheduledPublish: "0" | "1") => {
      if (!editingJobEvent.value) {
        return;
      }

      if (scheduledPublish === "1") {
        setEditingJobEvent(
          {
            ...editingJobEvent.value,
            scheduled_publish: true,
            preferred_publish_at:
              editingJobEvent.value.preferred_publish_at ||
              String(getBusinessDate(4).toDate())
          },
          { key: "preferred_publish_at" }
        );
      } else {
        setEditingJobEvent(
          {
            ...editingJobEvent.value,
            scheduled_publish: false
          },
          { key: "preferred_publish_at" }
        );
      }
    };

    const onClickPreview = async () => {
      try {
        await onClickSaveDraft(true);
        if (editingJobEvent.value?.event_id) {
          goToPreviewPage(editingJobEvent.value.event_id);
        }
      } catch (error) {
        store.commit("common/updateAlertView", {
          isVisible: true,
          title: "予期せぬエラーが発生しました。",
          message: "リロードして再度お試しください。"
        });
        throw error;
      }
    };

    const onClickSaveDraft = async (disabledSuccessModal = false) => {
      if (editingJobEvent.value) {
        try {
          await saveJobEvent();

          if (props.isNewJobEvent) {
            if (editingJobEvent.value?.event_id) {
              await router
                .push({
                  name: "JobEvent",
                  params: {
                    eventId: String(editingJobEvent.value.event_id)
                  }
                })
                .catch(() => {});
            }

            !disabledSuccessModal &&
              store.commit("common/updateAlertView", {
                isVisible: true,
                title: "下書きを保存しました",
                message: ""
              });
          }
        } catch (error) {
          if (error instanceof ValidationError) {
            return;
          }

          if (error instanceof BadRequestError) {
            const errorMessages = getErrorMessages(error);

            if (errorMessages.length) {
              store.commit("common/updateAlertView", {
                isVisible: true,
                title: "エラーが発生しました",
                message: errorMessages[0]
              });
              return;
            }
          }

          store.commit("common/updateAlertView", {
            isVisible: true,
            title: "予期せぬエラーが発生しました",
            message: "再読み込みを実行してください"
          });
          throw error;
        }
      }
    };

    const onClickPublish = async () => {
      validateAllProperties();
      if (jobEventErrors.value.length) {
        return;
      }
      // 掲載依頼モーダルを開く前に必ず下書き保存する
      await onClickSaveDraft(true);

      // 企業ロゴを設定していない場合はモーダルを表示する
      emit("checkCompanyLogo");
      if (!props.companyLogoUrl) {
        return;
      }

      togglePublishConfirmModal();
    };

    const onClickPublishConfirm = async () => {
      togglePublishConfirmModal();
      try {
        await submitJobEvent();
        togglePublishCompleteModal();
      } catch (error) {
        if (error instanceof ValidationError) {
          return;
        }

        if (error instanceof BadRequestError) {
          const errorMessages = getErrorMessages(error);

          if (errorMessages.length) {
            store.commit("common/updateAlertView", {
              isVisible: true,
              title: "エラーが発生しました",
              message: errorMessages[0]
            });
            return;
          }
        }

        store.commit("common/updateAlertView", {
          isVisible: true,
          title: "予期せぬエラーが発生しました。",
          message: "再読実行してください"
        });
        throw error;
      }
    };

    const onClickWithdrawSubmission = async () => {
      if (!editingJobEvent.value) {
        return;
      }
      try {
        await withdrawJobEvent();
        toggleWithdrawConfirmModal();
        toggleWithdrawCompleteModal();
      } catch (error) {
        store.commit("common/updateAlertView", {
          isVisible: true,
          title: "予期せぬエラーが発生しました。",
          message: "再読実行してください"
        });
        throw error;
      }
    };

    const onClickPublishCompleteModal = () => {
      if (!editingJobEvent.value) {
        return;
      }

      togglePublishCompleteModal();
    };

    const formatDate = (at: string) =>
      dayjs(new Date(at)).format("YYYY/MM/DD HH:mm");

    const withdrawSubmissionButtonLabel = computed(() => {
      return editingJobEvent.value?.approval_status === "waiting_for_publish"
        ? "予約取り消し"
        : "掲載依頼取り消し";
    });

    const disabledPublishButton = computed(() => {
      return editingJobEvent.value?.is_pre_entry_event === true;
    });

    return {
      editingJobEvent,
      comments,
      disabledEdit,
      jobEventErrors,
      setEditingJobEvent,
      getJobEventErrorMessage,
      jobEventValidate,

      onChangePreferredPublishAt,
      onChangeSelectedPreferredDateType,
      onClickPreview,
      onClickSaveDraft,
      onClickPublish,
      onClickPublishConfirm,
      onClickWithdrawSubmission,
      onClickPublishCompleteModal,
      getDisplayApprovalStatus,
      getDisplayPublicStatus,
      formatDate,

      disabledPublishButton,
      isShowPublishConfirmModal,
      togglePublishConfirmModal,
      isShowPublishCompletedModal,
      togglePublishCompleteModal,
      isShowWithdrawConfirmModal,
      toggleWithdrawConfirmModal,
      isShowWithdrawCompleteModal,
      toggleWithdrawCompleteModal,

      withdrawSubmissionButtonLabel,
      occWhite
    };
  }
});
